<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Edit VAS Configs</li>
            </ol>
          </div>
          <h4 class="page-title">Edit VAS config for Participant Id: {{participantID}}</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div *ngIf="!!participant" class="card-box">
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="form-group row">
              <label for="ServiceType" class="col-3 col-form-label">Service Type</label>
              <div class="col-9">
                <ng-select2 [(ngModel)]="ServiceType" [ngModelOptions]="{standalone: true}"
                            [data]="serviceTypes"
                            [options]="select2options" placeholder="Service Type"></ng-select2>
              </div>
            </div>

            <div class="form-group row">
              <label for="Provider" class="col-3 col-form-label">Provider</label>
              <div class="col-9">
                <ng-select2 [(ngModel)]="Provider" [ngModelOptions]="{standalone: true}"
                            [data]="providers"
                            [options]="select2options" placeholder="Provider"></ng-select2>
              </div>
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="" class="parsley-required">Provider is required.</li>
              </ul>
            </div>

            <div class="form-group row">
              <label for="VASRefNr" class="col-3 col-form-label">VAS Reference Number</label>
              <div class="col-9">
                <input [(ngModel)]="VASRefNr" class="form-control" id="VASRefNr" placeholder="VAS Ref Nr" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>

            <div class="form-group row">
              <label for="Commission" class="col-3 col-form-label">Commission <i class="fe-info" placement="top" ngbTooltip="Use comma(,) instead of period/fullstop(.) i.e. 1,3 "></i></label>
              <div class="col-9">
                <input [(ngModel)]="Commission" class="form-control" id="Commission" (keypress)="omit_special_char($event)" placeholder="Commission" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>

            <hr />


            <div class="form-group row" offset-3 col-9 *ngIf="error">
              <div class="col-10">
                <p class="text-danger">{{errorMessage}}</p>
              </div>
            </div>
            <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
              <ng-container *ngIf="!!createResult.message">
                <p class="text-danger">{{createResult.message}}</p>
              </ng-container>
            </div>


            <div class="form-group mb-0 justify-content-end row">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
